// Positioned text extraction via the vendored, version-pinned pdf.js
// (ADR 0006: self-hosted, sandboxed in its worker; the invoice never leaves
// the device on this path). Output is top-left-origin tokens.

import * as pdfjs from "../../vendor/pdf.min.mjs";
import workerUrl from "../../vendor/pdf.worker.min.mjs?url";
import type { Token } from "./types";

pdfjs.GlobalWorkerOptions.workerSrc = workerUrl;

export interface ExtractResult { tokens: Token[]; pages: number; totalChars: number }

export async function extractTokens(data: ArrayBuffer): Promise<ExtractResult> {
  const doc = await pdfjs.getDocument({ data }).promise;
  const tokens: Token[] = [];
  let totalChars = 0;

  for (let p = 1; p <= doc.numPages; p++) {
    const page = await doc.getPage(p);
    const viewport = page.getViewport({ scale: 1 });
    const content = await page.getTextContent();
    for (const it of content.items) {
      const str = it.str;
      if (!str || !str.trim()) continue;
      totalChars += str.trim().length;
      const scaleY = Math.abs(it.transform[3]) || Math.abs(it.transform[0]) || 10;
      tokens.push({
        str,
        page: p,
        x: it.transform[4],
        // pdf space is bottom-left origin; flip to top-left and anchor at the glyph top
        y: viewport.height - it.transform[5] - scaleY,
        w: it.width,
        h: scaleY,
      });
    }
  }
  return { tokens, pages: doc.numPages, totalChars };
}
